(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class KrivaHeader extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
    }

    connectedCallback() {
      this.section = this.closest('.section-header') || this.parentElement;
      this.stickyType = this.dataset.stickyType || 'always';
      this.scrollThreshold = Number(this.dataset.scrollThreshold || 20);
      this.lastScrollY = window.scrollY;
      this.mobileMenu = this.querySelector('[data-kriva-mobile-menu]');

      this.setHeight();
      this.startPageLoadAnimation();
      this.bindMobileMenu();
      this.bindDesktopOverlayState();
      this.bindCartSync();

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      document.addEventListener('keydown', this.onKeydown);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.setHeight());
        this.resizeObserver.observe(this);
      }

      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('keydown', this.onKeydown);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.cartObserver) this.cartObserver.disconnect();
    }

    setHeight() {
      const height = this.offsetHeight;
      if (this.section) {
        this.section.style.setProperty('--kriva-current-height', `${height}px`);
      }
      document.documentElement.style.setProperty('--header-height', `${height}px`);
    }

    startPageLoadAnimation() {
      if (!this.classList.contains('kriva-header-wrapper--animate-load')) {
        this.classList.add('is-page-loaded');
        return;
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          this.classList.add('is-page-loaded');
        });
      });
    }

    bindMobileMenu() {
      if (!this.mobileMenu) return;

      this.mobileMenu.addEventListener('toggle', () => {
        const isOpen = this.mobileMenu.open;
        this.classList.toggle('has-open-menu', isOpen);
        document.documentElement.classList.toggle('kriva-menu-open', isOpen);
      });

      this.querySelectorAll('[data-kriva-menu-close]').forEach((button) => {
        button.addEventListener('click', () => this.closeMobileMenu());
      });

      this.mobileMenu.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', () => this.closeMobileMenu());
      });
    }

    bindDesktopOverlayState() {
      this.querySelectorAll('.kriva-desktop-header details').forEach((detailsElement) => {
        detailsElement.addEventListener('toggle', () => {
          const desktopOverlayOpen = Array.from(
            this.querySelectorAll('.kriva-desktop-header details')
          ).some((item) => item.open);

          const mobileOpen = Boolean(this.mobileMenu && this.mobileMenu.open);
          this.classList.toggle('has-open-menu', desktopOverlayOpen || mobileOpen);
        });
      });
    }

    bindCartSync() {
      const desktopCart = this.querySelector('#cart-icon-bubble');
      const mobileCart = this.querySelector('#cart-icon-bubble-mobile');

      if (!desktopCart || !mobileCart || !('MutationObserver' in window)) return;

      const syncCart = () => {
        const currentDesktopCart = this.querySelector('#cart-icon-bubble');
        const currentMobileCart = this.querySelector('#cart-icon-bubble-mobile');

        if (
          currentDesktopCart &&
          currentMobileCart &&
          currentMobileCart.innerHTML !== currentDesktopCart.innerHTML
        ) {
          currentMobileCart.innerHTML = currentDesktopCart.innerHTML;
        }
      };

      this.cartObserver = new MutationObserver(syncCart);
      this.cartObserver.observe(this, {
        childList: true,
        subtree: true,
        characterData: true
      });

      syncCart();
    }

    closeMobileMenu() {
      if (!this.mobileMenu || !this.mobileMenu.open) return;
      this.mobileMenu.open = false;
      this.classList.remove('has-open-menu');
      document.documentElement.classList.remove('kriva-menu-open');

      const summary = this.mobileMenu.querySelector(':scope > summary');
      if (summary) summary.focus();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.closeMobileMenu();
    }

    onResize() {
      this.setHeight();
      if (window.matchMedia('(min-width: 990px)').matches) {
        this.closeMobileMenu();
      }
    }

    onScroll() {
      const currentScrollY = window.scrollY;
      const isScrolled = currentScrollY > this.scrollThreshold;

      this.classList.toggle('is-scrolled', isScrolled);

      if (this.stickyType === 'on-scroll-up') {
        const scrollingDown = currentScrollY > this.lastScrollY;
        const pastHeader = currentScrollY > this.offsetHeight;

        if (scrollingDown && pastHeader && !this.classList.contains('has-open-menu')) {
          this.classList.add('is-hidden');
        } else {
          this.classList.remove('is-hidden');
        }
      } else {
        this.classList.remove('is-hidden');
      }

      this.lastScrollY = Math.max(currentScrollY, 0);
    }
  }

  if (!customElements.get('kriva-sticky-header')) {
    customElements.define('kriva-sticky-header', KrivaHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
